/**
 * Sidebar Icon
 *
 */

export default function secondary(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.188a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75zm0 9.187a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75zm.75 8.438a.75.75 0 0 0 0 1.5h22.5a.75.75 0 0 0 0-1.5H.75z"
        fill="black"
      />
    </svg>
  )
}
